import BaseMapper from '../../BaseMapper';

const EventWithoutSeasonMapper = (data, context) => {
    return data;
};

export default EventWithoutSeasonMapper;
